import { createFileRoute, notFound } from "@tanstack/react-router";
import BlogPostPage from "@/pages/BlogPostPage";
import { getPost } from "@/data/posts";
import { canonicalUrl, pageHead } from "@/lib/site";

export const Route = createFileRoute("/blog/$slug")({
  beforeLoad: ({ params }) => {
    if (!getPost(params.slug)) throw notFound();
  },
  head: ({ params }) => {
    const post = getPost(params.slug);
    if (!post) return {};
    const url = canonicalUrl(`/blog/${post.slug}`);
    const articleSchema = {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      headline: post.title,
      description: post.metaDescription,
      datePublished: post.datePublished,
      image: post.image.startsWith("http")
        ? post.image
        : canonicalUrl(post.image),
      mainEntityOfPage: url,
      author: {
        "@type": "Organization",
        name: "Scotty's Land Specialist LLC",
        url: canonicalUrl("/"),
      },
      publisher: {
        "@type": "Organization",
        name: "Scotty's Land Specialist LLC",
        url: canonicalUrl("/"),
      },
    };
    return {
      ...pageHead(post.seoTitle, post.metaDescription, `/blog/${post.slug}`),
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(articleSchema),
        },
      ],
    };
  },
  component: () => <BlogPostPage slug={Route.useParams().slug} />,
});
